var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5257 43.8857C32.5486 43.8857 35.84 40.5943 35.84 36.5714V7.31429C35.84 3.29143 32.5486 0 28.5257 0H7.31429C3.29143 0 0 3.29143 0 7.31429V36.5714C0 40.5943 3.29143 43.8857 7.31429 43.8857H28.5257ZM13.3486 10.7886H22.3086C23.4057 10.7886 24.1371 11.52 24.1371 12.6171C24.1371 13.7143 23.4057 14.4457 22.3086 14.4457H13.3486C12.2514 14.4457 11.52 13.7143 11.52 12.6171C11.52 11.52 12.4343 10.7886 13.3486 10.7886ZM9.14286 20.1143H26.6971C27.7943 20.1143 28.5257 20.8457 28.5257 21.9429C28.5257 23.04 27.7943 23.7714 26.6971 23.7714H9.14286C8.04571 23.7714 7.31429 23.04 7.31429 21.9429C7.31429 20.8457 8.04571 20.1143 9.14286 20.1143ZM9.14286 29.44H26.6971C27.7943 29.44 28.5257 30.1714 28.5257 31.2686C28.5257 32.3657 27.7943 33.0971 26.6971 33.0971H9.14286C8.04571 33.0971 7.31429 32.3657 7.31429 31.2686C7.31429 30.1714 8.04571 29.44 9.14286 29.44Z",
    fill: "#1C7BDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc_icon.023aceecb17ebc2d784c4246611e3e66.svg";
export { ForwardRef as ReactComponent };